/**
 * Fonte única de destinos (C5) — alimenta rail, bottom nav, breadcrumb e badges. Porte do shell
 * do protótipo (Docs/V2/Tecnicos/tecnico/app.jsx: NAV mobile de 5 abas + NAV_DESK com Relatórios).
 *
 * `implemented` é a diferença deste arquivo para o protótipo: só destinos com view real entram na
 * navegação renderizada — nunca um item de menu que leva a tela vazia ou a um toast "em
 * construção". O array completo existe desde já porque o shell precisa da taxonomia inteira;
 * cada corte seguinte muda `implemented` para `true` ao entregar a view real.
 */
export interface Destination {
  readonly path: string;
  readonly name: string;
  readonly title: string;
  /**
   * Rótulo curto da barra inferior do celular. Existe só quando `title` não cabe em 320px de
   * viewport com cinco abas (60px por aba) — sem ele o rótulo seria cortado com reticências.
   */
  readonly shortTitle?: string;
  /** Ícone do protótipo (NAV/NAV_DESK em app.jsx) — só exibido, nunca lógica. */
  readonly icon: string;
  /** Só no rail desktop (Relatórios sai da barra do celular no protótipo). */
  readonly desktopOnly?: boolean;
  readonly implemented: boolean;
}

export const destinations: readonly Destination[] = [
  { path: '/inicio', name: 'inicio', title: 'Início', icon: '🏠', implemented: true },
  { path: '/disponiveis', name: 'disponiveis', title: 'Disponíveis', icon: '📥', implemented: true },
  { path: '/servicos', name: 'servicos', title: 'Meus serviços', shortTitle: 'Serviços', icon: '🔧', implemented: true },
  { path: '/agenda', name: 'agenda', title: 'Agenda', icon: '📅', implemented: true },
  { path: '/perfil', name: 'perfil', title: 'Perfil', icon: '👤', implemented: true },
  { path: '/relatorios', name: 'relatorios', title: 'Relatórios', icon: '📊', desktopOnly: true, implemented: true },
];

/** Só o que tem view real — é isto, não `destinations` inteiro, que vira item clicável de navegação. */
export const navigableDestinations: readonly Destination[] = destinations.filter((destination) => destination.implemented);

export function destinationByName(name: string): Destination | undefined {
  return destinations.find((destination) => destination.name === name);
}
